export enum FeedbackTipo {
  Positivo = 1,
  Negativo,
  Vista,
}
